import { render, staticRenderFns } from "./MainCalc.vue?vue&type=template&id=083789f6&"
import script from "./MainCalc.vue?vue&type=script&lang=js&"
export * from "./MainCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports